import { useEffect, useRef } from "react";
import { copyToClipboard } from "../utils/copyToClipboard";

// Клонирует элемент и убирает все потомки с data-copy-exclude перед получением текста
const getFilteredText = (el: Element): string => {
	const clone = el.cloneNode(true) as Element;
	clone.querySelectorAll("[data-copy-exclude]").forEach((node) => node.remove());
	return clone.textContent?.trim() ?? "";
};

export const useGlobalCopyOnClick = (onCopy?: (text: string) => void) => {
	const onCopyRef = useRef(onCopy);
	onCopyRef.current = onCopy;

	useEffect(() => {
		// map таймеров для каждого элемента — чтобы таймеры не пересекались между элементами
		const timers = new Map<Element, number>();

		const handler = async (e: MouseEvent) => {
			const target = e.target as Element | null;
			if (!target) return;

			// Ищем ближайший элемент с атрибутом data-copyable или data-copy-text
			const el = (target as Element).closest(
				"[data-copyable], [data-copy-text]",
			);
			if (!el) return;

			// Можно потребовать модификатор (например, Alt) — раскомментируйте при желании
			// if (!e.altKey) return;

			const dataset = (el as HTMLElement).dataset;
			const text = dataset.copyText ?? getFilteredText(el);
			if (!text) return;

			const ok = await copyToClipboard(text);
			if (ok) {
				onCopyRef.current?.(text);
			}
		};

		document.addEventListener("click", handler);
		return () => {
			document.removeEventListener("click", handler);
			// очистим все таймеры, которые ещё висят
			timers.forEach((id) => window.clearTimeout(id));
			timers.clear();
		};
	}, []);
};
